import { Component, OnInit } from '@angular/core';
import { TransactionsService } from '../../../../../resources/transactions/transactions.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as moment from 'moment';
import { Transaction } from '../../../../../model/transaction';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/combineLatest';

interface Filter {
  name: FilterName;
  asc: boolean;
}

type FilterName =
  | 'created_at'
  | 'card_no'
  | 'driver_name'
  | 'plate'
  | 'city'
  | 'amount';

type Base = 'months' | 'weeks' | 'days';

enum ranges {
  days = '1 dzień',
  weeks = '1 tydzień',
  months = '1 miesiąc'
}

@Component({
  selector: 'app-last-transactions',
  templateUrl: './last-transactions.component.html',
  styleUrls: ['./last-transactions.component.scss']
})
export class LastTransactionsComponent implements OnInit {
  range: string;
  transactions: Transaction[];
  loading = true;
  p = 0;

  private sort$ = new BehaviorSubject<Filter>({
    name: 'card_no',
    asc: true
  });

  private range$ = new BehaviorSubject('days');

  constructor(private transactionsService: TransactionsService) {}

  ngOnInit() {
    this.range$
      .asObservable()
      .do(() => (this.loading = true))
      .switchMap((range: Base) => {
        this.range = ranges[range].toString();
        return this.source(range);
      })
      .subscribe(data => {
        this.transactions = data;
        this.loading = false;
      });
  }

  source(range: Base): Observable<Transaction[]> {
    this.range = ranges[range].toString();
    return this.transactionsService
      .query(null, {
        start: moment()
          .subtract(1, range)
          .format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      })
      .combineLatest(this.sort$, (data: Transaction[], sort: Filter) => {
        return data.sort((a, b) => {
          return (
            (this.resolveValue(a, sort.name) > this.resolveValue(b, sort.name)
              ? 1
              : -1) * (sort.asc ? 1 : -1)
          );
        });
      });
  }

  changeSort(by: FilterName) {
    const previousFilter = this.sort$.getValue();
    if (by === previousFilter.name) {
      this.sort$.next({ ...previousFilter, asc: !previousFilter.asc });
    } else {
      this.sort$.next({ name: by, asc: true });
    }

    console.log(this.sort$.getValue());
  }

  changeRange(range) {
    this.range$.next(range);
  }

  private resolveValue(data: Transaction, filter: FilterName): any {
    switch (filter) {
      case 'created_at':
        return data.created_at;
      case 'card_no':
        return data.card_no;
      case 'driver_name':
        return data.driver.name;
      case 'plate':
        return data.vehicle.plate;
      case 'city':
        return data.station.city;
      case 'amount':
        return data.amount;
    }
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/stats/last-transactions/last-transactions/last-transactions.component.ts